(function () {
  'use strict';

  /*
   * =========================================================
   * HERB PHARM EXTERNAL LINK POPUP
   * =========================================================
   *
   * This script:
   * 1. Detects clicks on external links
   * 2. Prevents the external site from opening immediately
   * 3. Opens the Herb Pharm external-link popup
   * 4. Adds the destination URL to the CONTINUE button
   * 5. Displays the external website name
   *
   * The popup HTML must exist in theme.liquid:
   *
   * #interstitual_popup
   * #EzfyPopupLink
   *
   * =========================================================
   */


  /*
   * =========================================================
   * SETTINGS
   * =========================================================
   *
   * These are all considered internal Herb Pharm domains.
   * Links between these domains will NOT trigger the popup.
   */

  const INTERNAL_DOMAINS = [
    'herb-pharm.com',
    'herbpharm.co.uk'
  ];


  /*
   * =========================================================
   * CHECK IF A LINK IS EXTERNAL
   * =========================================================
   */

  function isExternalLink(link) {

    if (!link) {
      return false;
    }

    if (!link.href) {
      return false;
    }

    let destination;

    try {

      destination = new URL(
        link.href,
        window.location.href
      );

    } catch (error) {

      return false;

    }


    /*
     * Ignore mailto:, tel:, javascript:, etc.
     */
    if (
      destination.protocol !== 'http:' &&
      destination.protocol !== 'https:'
    ) {

      return false;

    }


    /*
     * Remove www. so that:
     *
     * www.herb-pharm.com
     * herb-pharm.com
     *
     * www.herb-pharm.co.uk
     * herb-pharm.co.uk
     *
     * are all treated as internal.
     */
    const hostname = destination.hostname
      .toLowerCase()
      .replace(/^www\./, '');


    /*
     * Check whether the destination belongs
     * to one of the internal Herb Pharm domains.
     */
    const isInternal = INTERNAL_DOMAINS.some(
      function (domain) {

        return (
          hostname === domain ||
          hostname.endsWith('.' + domain)
        );

      }
    );


    /*
     * Herb Pharm links are internal.
     */
    if (isInternal) {

      return false;

    }


    /*
     * Everything else is external.
     */
    return true;

  }


  /*
   * =========================================================
   * GET WEBSITE NAME
   * =========================================================
   */

  function getWebsiteName(link) {

    /*
     * First use the link's title attribute.
     */
    const title = link.getAttribute('title');

    if (
      title &&
      title.trim() !== ''
    ) {

      return title.trim();

    }


    /*
     * Next use the visible link text.
     */
    const text = link.textContent.trim();

    if (
      text &&
      text !== ''
    ) {

      return text;

    }


    /*
     * Finally use the destination domain.
     */
    try {

      const destination = new URL(
        link.href,
        window.location.href
      );

      return destination.hostname
        .replace(/^www\./, '');

    } catch (error) {

      return 'external website';

    }

  }


  /*
   * =========================================================
   * OPEN POPUP
   * =========================================================
   */

  function openPopup(link) {

    const popup = document.getElementById(
      'interstitual_popup'
    );

    const continueButton = document.getElementById(
      'EzfyPopupLink'
    );


    /*
     * If the popup HTML isn't available,
     * allow the link to work normally.
     */
    if (!popup) {

      console.warn(
        'External Link Popup: #interstitual_popup not found.'
      );

      return false;

    }


    if (!continueButton) {

      console.warn(
        'External Link Popup: #EzfyPopupLink not found.'
      );

      return false;

    }


    /*
     * Set the external URL.
     */
    continueButton.setAttribute(
      'href',
      link.href
    );


    /*
     * Get website name.
     */
    const websiteName = getWebsiteName(link);


    /*
     * Update all .url_name elements.
     */
    const websiteNameElements =
      popup.querySelectorAll('.url_name');


    websiteNameElements.forEach(
      function (element) {

        element.textContent = websiteName;

      }
    );


    /*
     * Show popup.
     */
    popup.classList.add(
      'EzfyPopup--visible'
    );


    /*
     * Prevent background scrolling.
     */
    document.documentElement.style.overflow = 'hidden';

    document.body.style.overflow = 'hidden';


    return true;

  }


  /*
   * =========================================================
   * CLOSE POPUP
   * =========================================================
   */

  function closePopup() {

    const popup = document.getElementById(
      'interstitual_popup'
    );


    if (!popup) {

      return;

    }


    popup.classList.remove(
      'EzfyPopup--visible'
    );


    /*
     * Restore scrolling.
     */
    document.documentElement.style.overflow = '';

    document.body.style.overflow = '';

  }


  /*
   * =========================================================
   * HANDLE EXTERNAL LINK CLICKS
   * =========================================================
   */

  function handleLinkClick(event) {

    /*
     * Find the nearest anchor element.
     *
     * This works if someone clicks:
     * - text
     * - an image
     * - an icon
     * - an SVG
     * - a span inside a link
     */
    const link = event.target.closest(
      'a[href]'
    );


    /*
     * Not a link.
     */
    if (!link) {

      return;

    }


    /*
     * Don't intercept the CONTINUE button
     * or anything else inside the popup.
     */
    if (
      link.closest('#interstitual_popup')
    ) {

      return;

    }


    /*
     * Don't intercept Shopify preview links.
     */
    if (
      link.href.includes('shopifypreview') ||
      link.href.includes('preview_theme_id')
    ) {

      return;

    }


    /*
     * Don't intercept internal Herb Pharm links.
     *
     * This now includes:
     *
     * herb-pharm.com
     * www.herb-pharm.com
     * herb-pharm.co.uk
     * www.herb-pharm.co.uk
     */
    if (!isExternalLink(link)) {

      return;

    }


    /*
     * Try to open the popup.
     */
    const popupOpened = openPopup(link);


    /*
     * Only prevent navigation if the popup
     * successfully opened.
     */
    if (popupOpened) {

      event.preventDefault();

      event.stopPropagation();

    }

  }


  /*
   * =========================================================
   * CLOSE BUTTON
   * =========================================================
   */

  function setupCloseButton() {

    const closeButton = document.querySelector(
      '.EzfyPopup-close'
    );


    if (!closeButton) {

      return;

    }


    closeButton.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        event.stopPropagation();

        closePopup();

      }
    );

  }


  /*
   * =========================================================
   * CLICK OUTSIDE POPUP TO CLOSE
   * =========================================================
   */

  function setupBackgroundClose() {

    const popup = document.getElementById(
      'interstitual_popup'
    );


    if (!popup) {

      return;

    }


    popup.addEventListener(
      'click',
      function (event) {

        /*
         * Only close if the visitor clicked
         * the dark overlay itself.
         */
        if (
          event.target === popup
        ) {

          closePopup();

        }

      }
    );

  }


  /*
   * =========================================================
   * CONTINUE BUTTON
   * =========================================================
   *
   * The button has target="_blank", so the
   * external website will open in a new tab.
   *
   * We simply close the popup when clicked.
   */

  function setupContinueButton() {

    const continueButton =
      document.getElementById(
        'EzfyPopupLink'
      );


    if (!continueButton) {

      return;

    }


    continueButton.addEventListener(
      'click',
      function () {

        closePopup();

      }
    );

  }


  /*
   * =========================================================
   * INITIALIZE
   * =========================================================
   */

  function initialize() {

    /*
     * Listen for clicks on the entire document.
     *
     * Using capture mode makes this work reliably
     * with Shopify sections and dynamically-created links.
     */
    document.addEventListener(
      'click',
      handleLinkClick,
      true
    );


    setupCloseButton();

    setupBackgroundClose();

    setupContinueButton();

  }


  /*
   * =========================================================
   * START SCRIPT
   * =========================================================
   */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();

  }

})();